import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import useModularPDPState from '../useModularPDPState';
import useProductBasicDetails from '../useProductBasicDetails';
const useModularPDPAvailableSizes = (id, slug) => {
  const $ = _c(8);
  const {
    data: basicDetails,
    loading: basicDetailsLoading
  } = useProductBasicDetails();
  const {
    data: t0,
    loading
  } = useModularPDPState(id, slug);
  const {
    modularState
  } = t0;
  basicDetails?.id;
  modularState?.preConfiguredProducts;
  let t1;
  bb0: {
    if (modularState?.preConfiguredProducts?.length || basicDetails?.id) {
      let t2;
      if ($[0] !== modularState?.preConfiguredProducts) {
        t2 = modularState?.preConfiguredProducts?.map(_temp);
        $[0] = modularState?.preConfiguredProducts;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      const availableSizesData = t2;
      t1 = availableSizesData;
      break bb0;
    }
    t1 = null;
  }
  const availableSizes = t1;
  const t2 = loading || basicDetailsLoading;
  const t3 = basicDetails?.id;
  let t4;
  if ($[2] !== availableSizes || $[3] !== t3) {
    t4 = {
      id: t3,
      available_sizes: availableSizes
    };
    $[2] = availableSizes;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = {
      loading: t2,
      data: t4
    };
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default useModularPDPAvailableSizes;
function _temp(preConfigProduct) {
  return {
    id: preConfigProduct.id,
    slug: preConfigProduct.slug
  };
}